import React, {useState} from 'react'
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap'
import ClaimableValue from './SubComponent/ClaimableValue';
import { useTheme } from '../../../../hooks/ThemeProvider';
import TotalStaked from './TotalStaked';

function MyStakings({  myStakes = [],
    loading,
    error,
    refetch,
    currentPage = 1,
    perPage = 10,
    totalItems = 0,
    onPageChange,
    onPerPageChange }) {
    const [itemsPerPage, setItemsPerPage] = useState(100);
    const { theme } = useTheme();
    // Calculate pagination
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentStakes = myStakes?.slice(startIndex, endIndex) || [];
    // console.log(currentStakes, 'currentStakes');

    // Format currency
    const formatCurrency = (amount) => {
        if (!amount) return '0';
        return `${parseFloat(amount).toLocaleString()}`;
    };

    // Format date
    const formatDate = (timestamp) => {
        if (!timestamp) return 'N/A';
        return new Date(parseInt(timestamp) * 1000).toLocaleDateString();
    };

    // Determine status based on claimTime
    const getStatus = (claimTime) => {
        const now = Math.floor(Date.now() / 1000);
        const claimTimeSeconds = parseInt(claimTime);
        return claimTimeSeconds <= now ? 'Expired' : 'Active';
    };

    // Calculate remaining days
    const getRemainingDays = (claimTime) => {
        const now = Math.floor(Date.now() / 1000);
        const claimTimeSeconds = parseInt(claimTime);
        const diff = claimTimeSeconds - now;
        if (diff <= 0) return '0 days';
        const days = Math.floor(diff / (24 * 60 * 60));
        return `${days} days`;
    };

    // Get display name for the pool
    const getPoolName = (stake) => {
        if (stake?.metadata?.name) {
            return stake.metadata.name;
        }
        return stake.contract?.substring(0, 10) + '...';
    };

    // Get display image for the pool
    const getPoolImage = (stake) => {
        if (stake?.metadata?.imageUrl) {
            return stake.metadata.imageUrl;
        }
        return "\\assets\\default.svg";
    };

    // Get display description/tagline
    const getPoolDescription = (stake) => {
        if (stake?.metadata?.description) {
            return stake.metadata.description.length > 16
                ? stake.metadata.description.substring(0, 16) + '...'
                : stake.metadata.description;
        }
        if (stake?.metadata?.tagline) {
            return stake.metadata.tagline;
        }
        return `Stake #${stake.id?.substring(0, 8)}`;
    };

    if (loading) {
        return (
            <div className="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
                <div className="table_main">
                    <p style={{ textAlign: 'center', padding: '20px' }}>Loading your stakes...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
                <div className="table_main">
                    <p style={{ textAlign: 'center', padding: '20px', color: 'red' }}>
                        Error loading stakes. Please try again.
                    </p>
                    <button onClick={refetch} style={{ margin: '0 auto', display: 'block' }}>
                        Retry
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div
            className="tab-pane fade"
            id="pills-contact"
            role="tabpanel"
            aria-labelledby="pills-contact-tab"
        >
            <div className="table_main">
                <div className="table_innner lastinnner">
                    <p className="one_sidee">#</p>
                    <p className="poolname">Creator</p>
                    <p>Total Staked</p>
                    <p>Claimable/Total Rewards</p>
                    <p>Lock Duration</p>
                    <p>Status</p>
                    <p></p>
                </div>

                {myStakes?.length === 0 ? (
                    <div className="table_innner lastinnner">
                        <p style={{ textAlign: 'center', padding: '20px', gridColumn: '1 / -1' }}>
                            No stakes found
                        </p>
                    </div>
                ) : (
                    myStakes?.map((stake, index) => {
                        const status = getStatus(stake.claimTime);
                        const isExpired = status === 'Expired';
                        // console.log(stake, 'stakestakestakestake')
                        return (
                            <div className="table_innner lastinnner" key={stake.id}>
                                <h4 className="one_sidee">{startIndex + index + 1}</h4>
                                <div className="under_table LASTTTABLE">
                                    <img
                                        src={getPoolImage(stake)}
                                        className="imgtable"
                                        alt="Pool"
                                        onError={(e) => {
                                            e.target.src = "\\assets\\default.svg";
                                        }}
                                    />
                                    <div>
                                        <h6>{getPoolName(stake)}</h6>
                                        <h5>{getPoolDescription(stake)}</h5>
                                    </div>
                                </div>
                                <h4><TotalStaked contract={stake?.contract}/> 
                                {/* {formatCurrency(stake.amount / 1e18)} */}
                                </h4>
                                <div className="under_table">
                                    <ClaimableValue stake={stake} />
                                </div>
                                <h4>{getRemainingDays(stake.claimTime)}</h4>

                                <div className={isExpired ? "expire" : "active"}>
                                    {status}
                                </div>
                                <div className="butttons_div">
                                    <Link to= {`/stakingpool?id=${stake?.contract}`}>
                                    <button>
                                        Details{" "}
                                        {
                                            theme === 'dark' ? <img src="\assets\white.svg" alt="Arrow" />
                                                : <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                    <path d="M9 4L11 6L9 8" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M1 6H11" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                        }

                                    </button>
                                    </Link>
                                </div>
                            </div>
                        );
                    })
                )}

                {totalItems > 0 && (
                    <div className="pagination_main">
                        <div className="left_side">
                            <h6>Showing {startIndex + 1} - {endIndex} out of {totalItems}</h6>
                            <Dropdown>
                                <Dropdown.Toggle variant="success" id="dropdown-basic">
                                    {perPage}{" "}
                                    <img src="\assets\droparrow.svg" alt="Dropdown" />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    {[10, 25, 50, 100].map((size) => (
                                        <Dropdown.Item
                                            key={size}
                                            onClick={() => onPerPageChange(size)}
                                        >
                                            <div className="drop_inside">
                                                <h5>Show: <span>{size} items</span></h5>
                                                {perPage === size && <img src="\assets\bluetick.svg" alt="Selected" />}
                                            </div>
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        <div className="right_side">
                            <div
                                className="arrows"
                                onClick={() => onPageChange(Math.max(1, currentPage - 1))}
                                style={{ cursor: currentPage === 1 ? 'not-allowed' : 'pointer', opacity: currentPage === 1 ? 0.5 : 1 }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                    <path d="M7.5 3L4.5 6L7.5 9" stroke="#243D70" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <div className="inner_middle">
                                {Array.from({ length: Math.min(5, totalPages) }, (_, i) => i + 1).map((page) => (
                                    <span
                                        key={page}
                                        onClick={() => onPageChange(page)}
                                        style={{
                                            cursor: 'pointer',
                                            fontWeight: currentPage === page ? 'bold' : 'normal',
                                            color: currentPage === page ? '#243D70' : '#999'
                                        }}
                                    >
                                        {page}
                                    </span>
                                ))}
                                {totalPages > 5 && <span>...</span>}
                                {totalPages > 5 && (
                                    <span
                                        onClick={() => onPageChange(totalPages)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {totalPages}
                                    </span>
                                )}
                            </div>

                            <div
                                className="arrows"
                                onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
                                style={{ cursor: currentPage === totalPages ? 'not-allowed' : 'pointer', opacity: currentPage === totalPages ? 0.5 : 1 }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                    <path d="M4.5 9L7.5 6L4.5 3" stroke="#243D70" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* Mobile view */}
            <div className="formobile">
                <div className="mobilebox d-none">
                    {myStakes?.map((stake, index) => {
                        const status = getStatus(stake.claimTime);
                        const isExpired = status === 'Expired';

                        return (
                            <div className="innerboxmain" key={stake.id}>
                                <div className="parentinner">
                                    <div className="firstinnner">
                                        <h6>#</h6>
                                        <h5>{startIndex + index + 1}</h5>
                                    </div>
                                    <div className="secondinnner">
                                        <h6>Creator</h6>
                                        <div className="parenttext">
                                            <span>
                                                <img
                                                    src={getPoolImage(stake)}
                                                    className="imgtable"
                                                    alt="Pool"
                                                    onError={(e) => {
                                                        e.target.src = "\\assets\\default.svg";
                                                    }}
                                                />
                                            </span>
                                            <div className="mainnnn">
                                                <h5>{getPoolName(stake)}</h5>
                                                <h6>{getPoolDescription(stake)}</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="secondinnner">
                                        <h6>Status</h6>
                                        <h5 className={isExpired ? "yellow" : "green"}>{status}</h5>
                                    </div>
                                    <div className="thirdinnner">
                                        <div className="butttons_div">
                                            <Link to={`/stakingpool?id=${stake?.contract}`}>
                                            <button>
                                                Details{" "}
                                                <img src="\assets\white.svg" alt="Arrow" /></button>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="mainbottom">
                                    <div className="innerbottomtex">
                                        <h6 className="live">Total Staked</h6>
                                        <h5 className="num">{formatCurrency(stake.amount / 1e18)}</h5>
                                    </div>

                                    <div className="innerbottomtex">
                                        <h6 className="live">Claimable/Total Rewards</h6>
                                        <h5 className="num">
                                            $0{" "}
                                            <span className="numspan">{formatCurrency(stake.amount / 1e18)}</span>
                                        </h5>
                                    </div>
                                    <div className="innerbottomtex">
                                        <h6 className="live">Lock Duration</h6>
                                        <h5 className="num">{getRemainingDays(stake.claimTime)}</h5>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    )
}

export default MyStakings